import { useMemo, useState } from "react";
import "../../../css/Containers/ContainerStyles.css";
import { DropdownMenu, DropdownMenuItem } from "../../DropdownMenu";
import SearchBoxContainer from "../SearchBoxContainer";
import { Icon } from "@iconify/react";
import { addAlpha, Colors } from "../../../utils/colors";
import { normalizePhoneInputToE164 } from "../../../utils/FormatPhoneNumber";
import DropdownArrowIcon from "../../DropdownsAndTabs/DropdownArrowIcon";

export enum SearchBoxContactsMode {
  NAME = "Name",
  PHONE = "Phone",
}

type SearchBoxContactsContainerProps = {
  searchTerm: string;
  handleSearch: (text: string) => void;
  searchMode: SearchBoxContactsMode;
  setSearchMode: (searchMode: SearchBoxContactsMode) => void;
};

// This search box component is used when searching contacts within a list by name or phone number
const SearchBoxContactsContainer = (props: SearchBoxContactsContainerProps) => {
  const { searchTerm, handleSearch, searchMode, setSearchMode } = props;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const styles = {
    filterContainer: {
      gap: 10,
      borderRadius: 8,
      paddingInline: 14,
      paddingBlock: 12,
      backgroundColor: Colors.WHITE1,
      border: `0.8px solid ${Colors.GRAY2}`,
    },
  };

  const dropdownItems: DropdownMenuItem[] = useMemo(
    () => [
      {
        title: SearchBoxContactsMode.NAME,
        icon: "ion:person",
        key: "search_name",
        onPress: () => {
          setSearchMode(SearchBoxContactsMode.NAME);
          handleSearch("");
        },
      },
      {
        title: SearchBoxContactsMode.PHONE,
        icon: "ion:call",
        key: "search_phone",
        onPress: () => {
          setSearchMode(SearchBoxContactsMode.PHONE);
          handleSearch("");
        },
      },
    ],
    [setSearchMode, handleSearch]
  );

  const labelStatusColor = useMemo(
    () =>
      searchTerm === "" || searchMode === SearchBoxContactsMode.NAME
        ? Colors.BLUE5
        : normalizePhoneInputToE164(searchTerm)
          ? Colors.GREEN2
          : Colors.RED2,
    [searchTerm, searchMode]
  );

  return (
    <div className="AlignedRow" style={{ gap: 10 }}>
      <DropdownMenu
        dropdownItems={dropdownItems}
        trigger={["click"]}
        placement="bottomLeft"
        onOpenChange={(isOpen: boolean) => setDropdownVisible(isOpen)}
        altWidth={140}
      >
        <div className="AlignedRowSelect" style={styles.filterContainer}>
          <span className="bodyMedium">{searchMode}</span>
          <DropdownArrowIcon
            isOpen={dropdownVisible}
            color={Colors.BLACK}
            height={14}
          />
        </div>
      </DropdownMenu>
      <SearchBoxContainer
        placeholder={`Search by ${
          searchMode === SearchBoxContactsMode.NAME ? "name" : "phone number"
        }...`}
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        containerStyles={{ marginTop: 0, width: 394 }}
        rightComp={
          <div
            style={{
              alignSelf: "center",
              color: labelStatusColor,
              backgroundColor: addAlpha(labelStatusColor, 0.1),
              borderRadius: 4,
              paddingBlock: 4,
              paddingInline: 6,
              border: `0.5px solid ${labelStatusColor}`,
              marginRight: 14,
            }}
          >
            <span className="OneLineText" style={{ fontSize: 10 }}>
              {searchMode === SearchBoxContactsMode.NAME ? "partial" : "exact"}
            </span>
          </div>
        }
      />
    </div>
  );
};

export default SearchBoxContactsContainer;
